import { ref } from 'vue'
import axios from '@/api'
import type { Agent, Team, LaravelMeta } from '@/types/types'

// Module-level singletons so App.vue (which kicks off getAgents on mount and
// when opening the transfer panel) and TransferPanel share the same lists,
// filters, and pagination state.
const agents = ref<Agent[]>([])
const agents_meta = ref<LaravelMeta>({} as LaravelMeta)
const agents_status = ref('online')
const agents_search = ref<string | null>(null)
const teams = ref<Team[]>([])
const team_id = ref<number | null>(null)
const transfer_type = ref('user')

const getAgents = async (page = 1) => {
  if (page < 1) return

  const response = await axios.get('/api/v1/users/paginated', {
    params: {
      page,
      status: agents_status.value,
      search: agents_search.value,
      team_id: team_id.value,
    },
  })
  agents.value = response.data.data
  agents_meta.value = response.data.meta
}

const getTeams = async () => {
  const response = await axios.get('/api/v1/teams')
  teams.value = response.data.data
}

export function useTransfer() {
  return {
    agents,
    agents_meta,
    agents_status,
    agents_search,
    teams,
    team_id,
    transfer_type,
    getAgents,
    getTeams,
  }
}
